import CatSitting from './CatSitting';

export default CatSitting;
